import React from 'react';
import ReactDOM from 'react-dom';
import { Field,reduxForm,formValueSelector } from 'redux-form';
import Select from 'react-select';
import { connect } from 'react-redux'
import LoadingSmall from '../../../../components/LoadingSmall.js';
import Loading from '../../../../components/Loading.js';
import axios from 'axios';

const validate = values => {
    const errors = {}

    if (!values.AD_ACCOUNT || values.AD_ACCOUNT == '') {
        errors.AD_ACCOUNT = 'Required'
    }

    return errors
}

const renderField = ({ input, name,className,placeholder, title, type, meta: { touched, error } }) => (
    <div className={`form-group form-material floating ${touched && error ? 'has-danger':''}`} data-plugin="formMaterial">
        <input {...input}  placeholder={placeholder} name={name} className={className} type={type}/>
        <label className="floating-label">{title}</label>
        <small className="text-help">{touched && ((error && <span>{error}</span>))}</small>
    </div>
)

const dropdownField = ({ input, options,name,className,placeholder, title, type, meta: { touched, error } }) => (
    <div className={`form-group form-material floating ${touched && error ? 'has-danger':''}`} data-plugin="formMaterial">
        <Select
            value={input.value}
            onChange={input.onChange}
            onBlur={() => input.onBlur(input.value)}
            options={options}
            placeholder={placeholder}
            simpleValue
        />
        <small className="text-help">{touched && ((error && <span>{error}</span>))}</small>
    </div>
)

const dropdownFieldd = ({ name,className, title, options, initialValue, meta: { touched, error } }) => (
    <div className={`form-group form-material floating ${touched && error ? 'has-danger':''}`} data-plugin="formMaterial">
        <select name={name} className="form-control">
            {
                initialValue ?
                    <option value="">{initialValue}</option>
                    :null
            }

            {
                options.map(item => {
                    return <option key={item.value} value={item.value}>{item.name}</option>
                })
            }
        </select>
        <label className="floating-label">{title}</label>
        <small className="text-help">{touched && ((error && <span>{error}</span>))}</small>
    </div>
)

class FacebookAds extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            accounts:[],
            isLoading:true,
        }

        this.generateAdAccountsList = this.generateAdAccountsList.bind(this);
    }

    componentWillMount() {
        axios.get('/apps/FacebookAds/adAccounts').then(res => {
           this.setState({accounts:res.data,isLoading:false});
        });
    }

    generateAdAccountsList() {
        let list = [];

        this.state.accounts.map(item => {
           list.push({
               'label':item.name+' - '+item.id.replace('act_',''),
               'value':item.id,
           })
        });

        return list;
    }



    render() {
        const { handleSubmit } = this.props;

        return (
            <form onSubmit={handleSubmit}>
                {this.props.err ?
                    <div className="alert dark alert-icon alert-danger alert-dismissible" role="alert">
                        <i className="icon wb-close" aria-hidden="true"></i>
                        {this.props.err}
                    </div>
                    :null}
                <div className="row">
                    <div className="col-sm-12">
                        <Field component={dropdownField} placeholder="Select ad account" name="AD_ACCOUNT"
                               initialValue="Select ad account"
                               options={this.generateAdAccountsList()} title="Facebook Ad account" />
                    </div>
                </div>

                <div className="row m-t-20">
                    <div className="col-sm-12">
                        {
                            this.props.isWaiting
                                ?
                                <LoadingSmall />
                                :
                                <button type="submit" className="btn btn-dark btn-block">{this.props.app.installed ? 'Update':'Install'}</button>
                        }
                    </div>
                </div>


            </form>
        );
    }
}


// Decorate the form component
FacebookAds = reduxForm({
    form: 'FacebookAds',
    validate,
})(FacebookAds);

FacebookAds = connect(
    state => ({

    })
)(FacebookAds)

export default FacebookAds;


// WEBPACK FOOTER //
// ./containers/apps/apps/forms/FacebookAds.js